export default function* termsAndConditionSaga() {
	// See example in containers/HomePage/saga.js
}
